import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import LayerFarmProcessActions from '../../Stores/LayerFarmProcess/Actions';

import LayerFarmListTable from '../LayerFarmList/LayerFarmListTable';
import LayerFarmExcelTable from '../LayerFarmExcel/LayerFarmExcelTable';

const { TabPane } = Tabs;

class LayerFarmProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchList } = this.props;
    if (curSiteFlowId > 0) {
      fetchList();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchList } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchList();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/layerFarm/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'LAYER_FARM_LIST' && <LayerFarmListTable match={match} />}
        {match.params.proc_type === 'LAYER_FARM_EXCEL' && <LayerFarmExcelTable match={match} />}
      </Card>
    );
  }
}

LayerFarmProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchList: PropTypes.func
};

LayerFarmProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchList() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.layerFarmProcess.process,
  processIsLoading: state.layerFarmProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchList: () => dispatch(LayerFarmProcessActions.layerFarmProcessFetchList())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LayerFarmProcessScreen));
